//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
import { getUrlArray } from '../vendor/url-helper-functions';
import { filterQandas } from '../custom/qanda';
import { filterItems } from '../custom/filter-select-history';
import { filterGlossary } from '../blocks/glossary';

(function() {
	if (typeof window.CustomEvent === "function") return false;

	function CustomEvent(event, params) {

		params = params || { bubbles: false, cancelable: false, detail: null };
		var evt = document.createEvent("CustomEvent");

		evt.initCustomEvent(
			event,
			params.bubbles,
			params.cancelable,
			params.detail
		);
		return evt;
	}
	window.CustomEvent = CustomEvent;
})();

export function eventedPushState(state, title, url) {
	var pushChangeEvent = new CustomEvent("pushstate", {
		detail: {
			state,
			title,
			url
		}
	});
	window.dispatchEvent(pushChangeEvent);
	return history.pushState(state, title, url);
}

export function smartPushState(filterby, filter, slug, filterbyInUrl = false, filterInParam = false ) {

	var urlArray = getUrlArray();
	// Add defensive programming to prevent undefined errors
	if (!urlArray || urlArray.length < 4) {
		console.warn('URL array is too short or undefined:', urlArray);
		return;
	}
	var path = urlArray[3];
	var url = '';

	if ( slug ) {
		eventedPushState(
			{ filterby: filterby, filter: filter, slug: slug },
			'',
			'/' + path + '/' + filter + '/' + slug
		);
	} else {
		url = '/' + path + '/' + filter;

		if ( filterbyInUrl ) {
			url = '/' + path + '/' + filterby + '/' + filter;
		}

		if ( filterInParam ) {
			url = '/' + path + '/?filter=' + filter;
		}

		eventedPushState({ filterby: filterby, filter: filter }, '', url );
	}
}

jQuery(window).on("pushstate popstate", function( event ) {
	var state = null;
	var filter = null;
	var slug = null;
	var filterby = null;

	//handling different data sturctures of pushstate and popstate events
	if ( event.detail && event.detail.state ) {
		state = {
			filter: event.detail.state.filter,
			slug: event.detail.state.slug,
			filterby: event.detail.state.filterby
		};
	}
	if ( event.originalEvent && event.originalEvent.state ) {
		state = {
			filter: event.originalEvent.state.filter,
			slug: event.originalEvent.state.slug,
			filterby: event.originalEvent.state.filterby
		};
	}
	if ( state ) {

		filter = state.filter;
		slug = state.slug;
		filterby = state.filterby;

		// Call appropriate filter function based on filterby
		if (filterby === "alpha") {
			filterGlossary(filterby, filter, slug);
		} else {
			filterQandas(filterby, filter, slug );
			filterItems(filterby, filter );
		}
	}
});
